import { useEffect, useState, useMemo } from "react";
import AxiosClient from "../../assets/AxiosClient";
import Card from "../../componants/Card";
import CountryChart from "../../data/CountryChart";
import PositionChart from "../../data/PositionChart";
import GenderChart from "../../data/GenderChart";
import PresentChart from "../../data/PresentChart";
import AttendanceStatistics from "../../data/AttendanceStatistics";

const DATES = ["2026-08-28"];

const NDashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await AxiosClient.get("/Dashborad/users/1");
        setUsers(res.data?.users ?? []);
      } catch (err) {
        console.error("Error loading users:", err);
        setError("Failed to load dashboard data.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const pendingUsers = useMemo(
    () => users.filter((u) => u.status === "pending"),
    [users]
  );

  const acceptedUsers = useMemo(
    () => users.filter((u) => u.status === "accepted"),
    [users]
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <h1 className="mb-4 fw-semibold">Dashboard</h1>

      <div className="row g-3 mb-4">
        <div className="col-lg-6 col-md-6">
          <Card
            icon="weekend"
            title="Registration Request"
            value={`${pendingUsers.length} responses`}
            users={pendingUsers}
            coll="dark"
          />
        </div>
        <div className="col-lg-6 col-md-6">
          <Card
            icon="weekend"
            title="Registered Attendants"
            value={`${acceptedUsers.length} Attendants`}
            users={acceptedUsers}
            coll="info"
          />
        </div>
      </div>

      <div className="row g-3">
        <div className="col-12">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h5 className="card-title text-info mb-3">
                Attendees by Country of Residence
              </h5>
              <CountryChart attendees={acceptedUsers} />
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h5 className="card-title mb-3">Attendees by Position</h5>
              <PositionChart attendees={acceptedUsers} />
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              <h5 className="card-title mb-3">Attendees by Gender</h5>
              <GenderChart attendees={acceptedUsers} />
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-body">
              <h5 className="card-title mb-3">Attendees by Present</h5>
              <PresentChart attendees={acceptedUsers} />
            </div>
          </div>
        </div>

        {DATES.map((date) => (
          <div key={date} className="col-lg-6">
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <AttendanceStatistics date={date} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NDashboard;